import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { PROOFREADER_TRANSCRIPT_SUBMIT_URL } from '../../../../constants/ApiUrlConstants';
import { DASHBOARD_ROUTE } from '../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import history from '../../../../features/history';
import { vendorNextTranscriptFailure, vendorNextTranscriptSuccess } from '../actions';

const VendorNextTrnascriptAPI = (action) => postApiRequest(PROOFREADER_TRANSCRIPT_SUBMIT_URL, action);

function forwardTo(location) {
  history.push(location);
}

function* handleVendorNextTrnascript(action) {
  try {
    const response = yield call(VendorNextTrnascriptAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
      yield call(forwardTo, DASHBOARD_ROUTE);
    }
    yield put(vendorNextTranscriptSuccess(response));
  } catch (error) {
    yield put(vendorNextTranscriptFailure(error));
  }
}

export function* watchVendorNextTrnascript() {
  yield takeLatest(types.VENDOR_NEXT_TRANSCRIPT_REQUEST, handleVendorNextTrnascript);
}
